import { render } from "./ChickenMainCourse.vue?vue&type=template&id=59ce2848"
import script from "./ChickenMainCourse.vue?vue&type=script&lang=js"
export * from "./ChickenMainCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__